import React from 'react'
import { FormControlLabel, Checkbox, Box, Typography } from '@mui/material'
import { GRAY_COLORS } from 'asterX-UI'

export const ConditionalCheckboxList = ({ data }) => {
  return (
    <Box display="flex" flexWrap="wrap" gap={3}>
      {data.map((item, index) => (
        <FormControlLabel
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: 2,
            border: `1px solid ${GRAY_COLORS[200]}`,
            borderRadius: '8px',
            padding: 2
          }}
          key={index}
          control={
            <Checkbox
              color={'primary'}
              variant="contained"
              checked={item.checked}
              sx={{
                padding: 0
              }}
            />
          }
          label={<Typography sx={{ fontSize: '14px', fontWeight: 600 }}>{item.label}</Typography>}
        />
      ))}
    </Box>
  )
}

export default ConditionalCheckboxList
